import { getSelectedHotel } from "actions/hotel";
import { useQuery } from "graphql/utils";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { GET_PMS_STATUS } from "graphql/queries/hotel";


export const useGetPMSStatus = () => {
    const project = useSelector(getSelectedHotel);

    const {
        query: loadData,
        called: loadDataCalled,
        data: pmsStatus,
        ...q
    } = useQuery({
        query: GET_PMS_STATUS.query,
        defaultVars: {
            hotelRef: project?.ref || null
        },
    });

    useEffect(() => {
        if (!loadDataCalled && project?.ref) {
            loadData();
        }
    }, [project?.ref]);


    return { pmsStatus: pmsStatus?.getPMSStatus || false, ...q };
};